export default __webpack_public_path__ + "static/media/konan.f062e7a3.png";